import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';


export default function Navbar(props) {

    return (
        <div>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`} >
                <div className="container-fluid">
                    <a className="navbar-brand" href="/TextUtils-React.js">{props.title}</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link  onClick={props.toggletitle1} className="nav-link active" aria-current="page" to="/TextUtils-React.js/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link onClick={props.toggletitle2} className="nav-link" to="/about">About</Link>
                            </li>

                        </ul>
                     
                        <div className="form-check form-switch">
                            <input onClick={props.togglemode} className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

    )
}

Navbar.propTypes = {
    title: PropTypes.string
};

Navbar.defaultProps = {
    title: 'Title Here'
};
